import { DcsPermissions } from 'types'
import store from './store'

//user state helpers
export const hasPermission = (permissionId: DcsPermissions) => {
    const { permissions } = store.getState().user
    return permissions.find((id: number) => id === permissionId) !== undefined
}

export const hasAnyPermission = (permissionIds: Array<DcsPermissions>) => {
    const { permissions } = store.getState().user
    return permissions.some((id: number) => permissionIds.some(id2 => id2 === id))
}